import { createFileRoute, Outlet } from '@tanstack/react-router';
import { FeatureFlag } from '@mews-commander/enums';
import { OptimusProvider } from '@mews-commander/ui';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Settings/Contracts/_library')({
    beforeLoad: ({ context: { checkFeatureFlag } }) => {
        checkFeatureFlag(FeatureFlag.contractingTemplateMappingEnabled);
    },
    component: () => (
        <OptimusProvider density="spacious">
            <Outlet />
        </OptimusProvider>
    ),
    staticData: {
        owner: MewsTeam.Spacetime,
        type: RouteType.Frontend,
    },
});
